export class ConfigNotLoadFromServerError extends Error {
  constructor() {
    super('Конфигурация для модуля CTF не была загружена с сервера')
  }
}